import React from 'react';
import PropTypes from 'prop-types';
import ContentCard from '../content-card';
import { Container } from '../styled/containers';
import { CardRow } from './styles';

/**
 * Displays a grid of Card components with a customizable column count
 */
const CardGrid = ({ contentCards = [], columns = 3 }) => {
  if (!contentCards || !contentCards.length) return null;

  return (
    <Container>
      <CardRow $columns={columns}>
        {contentCards.map((card, i) => (
          <ContentCard
            tabIndex="-1"
            key={card.id}
            title={card.title}
            description={card.description}
            image={card.image}
            link={card.link}
            currentCardCount={i}
            cardCount={contentCards.length}
          />
        ))}
      </CardRow>
    </Container>
  );
};

CardGrid.propTypes = {
  contentCards: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      link: PropTypes.object.isRequired,
      image: PropTypes.object,
    })
  ),
  columns: PropTypes.number.isRequired,
};

export default CardGrid;

export const CardGridAssembly = ({ contentfulData }) => (
  <CardGrid
    contentCards={contentfulData.contentCards}
    columns={contentfulData.columns}
  />
);

CardGridAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
